<app-strategy-list />
